/* eslint-disable */
import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  Renderer2,
  ElementRef,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { MexGridPageDataService } from "../mex-grid-page-data.service";
import { MexGridTableComponent } from "../mex-grid-table/mex-grid-table.component";
import { Subscription } from "rxjs";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-mex-grid-tab",
  templateUrl: "./mex-grid-tab.component.html",
  styleUrls: ["./mex-grid-tab.component.scss"],
  host: { class: "mex-grid-tab-component" },
  encapsulation: ViewEncapsulation.None,
})
export class MexGridTabComponent implements OnInit {
  @ViewChild(MexGridTableComponent)
  mexGridTable: MexGridTableComponent;
  mexGridTabs = [];
  source = "";
  ticker: string;
  cut: string;
  pg: string;
  selectedCurrency: string = "Base";
  listenToTabClick: Function;
  listenToTabClickAfterLPSwitch: Function;
  pageParamsSubcription: Subscription;
  apiEP: string = window.apiUrl;

  //used for tab auto scroll when hidden
  scrollLetftBtn: HTMLElement;
  scrollRightBtn: HTMLElement;
  tabsContainer: HTMLElement;
  tabScrollTimeout;
  selectedTabIndex;

  constructor(
    private store: Store<AppState>,
    private mexService: MexGridPageDataService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private appService: AppService,
  ) {}
  ngOnInit() {
    this.pageParamsSubcription = this.store
      .select(stateGetter("navigationSettings", "pageParams"))
      .subscribe((pageParams) => {
        const { ticker, cut, pg, source } = pageParams;
        // Set active tab on route change
        if (this.mexGridTabs && this.mexGridTabs.length) {
          for (let i = 0; i < this.mexGridTabs.length; i++) {
            const currentItem = this.mexGridTabs[i];
            if (currentItem.shortName.toLowerCase() === pg.toLowerCase()) {
              this.selectedTabIndex = i;
            }
          }
        }
        const summonFBar = new CustomEvent("SummonFBar", {
          detail: { data: {} },
        });
        window.dispatchEvent(summonFBar);
        // added to prevent extra tabs api calls
        if (
          ticker === this.ticker &&
          cut === this.cut &&
          !source &&
          this.cut.toLowerCase() !== "sch"
        ) {
          return;
        }
        if (source && ticker === this.ticker && source === this.source) {
          return;
        }
        this.ticker = ticker;
        this.cut = cut;
        this.pg = pg;
        this.source = source;
        this.mexService
          .getGridTabs(ticker, cut, source)
          .subscribe((response: any) => {
            let tabsArr = response.data;
            // if (this.cut.toLowerCase() === "sch") {
            //   if (this.pg.toLowerCase() === "kv") {
            //     tabsArr = [response.data[0]];
            //   } else {
            //     let tabs = response.data.filter((data) => {
            //       if (data.values) {
            //         for (let a of data.values) {
            //           if (a.shortName === this.pg) {
            //             return data;
            //           }
            //         }
            //       }
            //     });
            //     tabsArr = tabs.length > 0 ? tabs[0].values : [];
            //   }
            // } else {
            //   tabsArr = response.data;
            // }
            this.mexGridTabs = tabsArr.map((tab, index) => {
              if (tab.shortName.toLowerCase() == this.pg.toLowerCase()) {
                this.selectedTabIndex = index;
              }

              tab.link = this.source
                ? `/mex/${this.ticker}/${this.cut}/${tab.shortName}/${source}`
                : `/mex/${this.ticker}/${this.cut}/${tab.shortName}`;
              return tab;
            });
          });
      });
  }
  updateMexBreadCrumbTab() {
    setTimeout(() => {
      let tabSection = this.elementRef.nativeElement.querySelectorAll(
        ".mex-grid-tab-component [nz-tab-label]",
      );
      //A for-loop here since the tabSection is a nodeList
      for (let i = 0; i < tabSection.length; i++) {
        this.listenToTabClick = this.renderer.listen(
          tabSection[i],
          "click",
          (event) => {
            const changeBreadCrumbDetail = new CustomEvent(
              "changeBreadCrumbDetail",
              { detail: { tabName: event.target.innerText, cut: this.cut } },
            );
            window.dispatchEvent(changeBreadCrumbDetail);
          },
        );
      }

      //When the page loads first, replace the tab short name coming in the API, with the full name
      let selectedTabEl = this.elementRef.nativeElement.querySelectorAll(
        ".mex-grid-tab-component a.selected-tab",
      );
      if (selectedTabEl.length > 0) {
        let selectedTab = selectedTabEl[0].innerText;
        const changeBreadCrumbDetail = new CustomEvent(
          "changeBreadCrumbDetail",
          { detail: { tabName: selectedTab, cut: this.cut } },
        );
        window.dispatchEvent(changeBreadCrumbDetail);
      }
    }, 1000);
  }

  ngAfterViewInit() {
    // Although this is the last hook to be called, the template has not rendered yet.
    // Thus adding a setTimeout() here to ensure the elements are available.
    this.updateMexBreadCrumbTab();

    // This is triggered to rebind the clicks on a new set of tabs.
    // Happens when we switch between views.
    window.addEventListener("bindMyTabClicks", () => {
      let tabSection = this.elementRef.nativeElement.querySelectorAll(
        ".mex-grid-tab-component [nz-tab-label]",
      );
      //A for-loop here since the tabSection is a nodeList
      for (let i = 0; i < tabSection.length; i++) {
        this.listenToTabClickAfterLPSwitch = this.renderer.listen(
          tabSection[i],
          "click",
          (event) => {
            const changeBreadCrumbDetail = new CustomEvent(
              "changeBreadCrumbDetail",
              { detail: { tabName: event.target.innerText, cut: this.cut } },
            );
            window.dispatchEvent(changeBreadCrumbDetail);
          },
        );
      }
    });
  }

  onMEDataCurrencySet(currency: string) {
    this.selectedCurrency = currency;
    this.appService.mexPageExcelDisableChange.next(currency);
  }

  currencyChange(currency) {
    this.mexGridTable.onCurrencyChange(currency);
    this.appService.mexPageExcelDisableChange.next(currency);
  }

  ngOnDestroy() {
    if (this.listenToTabClick) {
      this.listenToTabClick();
    }
    if (this.pageParamsSubcription) {
      this.pageParamsSubcription.unsubscribe();
    }
    if (this.listenToTabClickAfterLPSwitch) {
      this.listenToTabClickAfterLPSwitch();
    }

    if (this.tabScrollTimeout) {
      clearTimeout(this.tabScrollTimeout);
    }

    if (this.mexGridTabs) {
      this.mexGridTabs = null;
    }
  }
}
